module.exports = __webpack_public_path__ + "img/tema-3-20.179ea1ed.png";